import './index.css'; // or './App.css'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Profiling from './routes/Profiling/Profiling';
import Tools from './routes/Tools/Tools';
import ToolDetail from './routes/ToolDetail/ToolDetail';

function App() {
  return (
    <Router>
      <Routes>
          <Route path="/" element={<Profiling />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/tools/:toolSlug" element={<ToolDetail />} />
      </Routes>
    </Router>
  );
}

export default App;
